import React, { Component } from 'react';
import { Form, Modal } from 'antd';
import SearchHr from '@comm/SearchHr';

const FormItem = Form.Item;

class FormModalUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    const {
      handleSubmit,
      form: { validateFields },
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const params = {
          uuids: values.uuids,
        };
        console.table(values.uuids);
        handleSubmit(params);
      }
    });
  };

  submit = () => {
    const data = this.props.form.getFieldsValue();
    data.orgUuid = this.state.orgUuid;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handSubmit(data);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        title="业务部门关联人员"
        onOk={this.handleOk}
        onCancel={this.props.handleCancel}
        visible
      >
        <Form>
          <FormItem label="关联人员">
            {getFieldDecorator('uuids', {
              rules: [{ required: true, message: '请选择要关联的人员' }],
            })(<SearchHr isMultiple="multiple" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(FormModalUsers);



// WEBPACK FOOTER //
// ./src/components/hr/workorg/ModalUsers.js